import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Zap, Cpu, Activity } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DWaveOptimizationWidget() {
  const [solverData, setSolverData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/infrastructure/solver/dwave`).then(r => setSolverData(r.data)).catch(() => {});
  }, []);

  if (!solverData) return null;

  return (
    <Card className="bg-[var(--qn-card)] border-[var(--qn-border)]" data-testid="dwave-optimization-widget">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
          Quantum Engine
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-[var(--qn-foreground-muted)]">Solver</span>
          <span className="text-sm font-medium text-[var(--qn-foreground)]">Classical (Primary)</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-[var(--qn-foreground-muted)]">D-Wave QPU</span>
          <Badge
            className={solverData.dwave?.status === "active"
              ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
              : "bg-gray-500/10 text-gray-400 border-gray-500/20"}
            data-testid="dwave-solver-badge"
          >
            <Zap className="w-3 h-3 mr-1" />
            {solverData.dwave?.status === "active" ? "Available" : "Inactive"}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-[var(--qn-foreground-muted)]">Annealing Cycles</span>
          <span className="text-sm font-medium text-[var(--qn-foreground)]">1,000/s</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-[var(--qn-foreground-muted)]">Classical Engine</span>
          <Badge className="bg-emerald-500/10 text-emerald-400 border-emerald-500/20" data-testid="classical-solver-badge">
            <Activity className="w-3 h-3 mr-1" /> Active
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
}
